/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";

export const GET_DOCUMENT_DOWNLOAD_LINK = gql`
  query GetDocumentDownloadLink($input: DocumentDownloadLinkInput) {
    getDocumentDownloadLink(input: $input)
  }
`;
